/** The studio-local (Melbourne, +10:00) calendar day of an instant, as YYYY-MM-DD.
 * Robust to whether the ISO carries a +10:00 offset or a UTC Z suffix (the sim clock advance
 * emits Z), so day-matching never drifts by a day for morning-AEST times. Idempotent for +10:00
 * and date-only inputs. ASSUMPTION: studio-local is +10:00 (AEST), matching the finance seeds and
 * CLOCKOFF_HOUR. */
export function dayKey(iso: string): string {
  return new Date(new Date(iso).getTime() + 10 * 60 * 60 * 1000).toISOString().slice(0, 10);
}
